import { defineComponent as _defineComponent } from 'vue'
import {
        computed, unref,
    } from 'vue';
    import { type Size } from '@ve/components/button/common/Button';
    import ButtonCommon from '@ve/components/button/desktop/Button.vue';
    import { formatNumber } from '@shared/lib';
    import priceSectionsData from '../config/priceSectionsData';
    import useBudgetFilterModel from '../lib/useBudgetFilterModel';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'PriceSelectors',
  props: {
    minPrice: null,
    maxPrice: null,
    size: null
  },
  setup(__props: any) {

const props = __props as {
        minPrice: number;
        maxPrice: number;
        size: Size,
    }

    

    const { maxPriceFilter, setMaxPrice } = useBudgetFilterModel();

    const clickPriceSelector = (price: number) => {
        const isActivePrice = price === unref(maxPriceFilter);
        if (isActivePrice) {
            setMaxPrice(null);
            return;
        }
        setMaxPrice(price);
    };

    const MAX_PRICE_SELECTORS = 6;

    const priceSections = computed(() => priceSectionsData
      .filter((priceSection) => (props.minPrice <= priceSection && priceSection <= props.maxPrice))
      .slice(0, MAX_PRICE_SELECTORS));

    const prices = computed(() => {
      return unref(priceSections).map((priceSection) => {
        return {
          section: priceSection,
          sectionText: formatNumber(priceSection),
        }
      });
    })

    


return { __sfc: true,props, maxPriceFilter, setMaxPrice, clickPriceSelector, MAX_PRICE_SELECTORS, priceSections, prices, ButtonCommon }
}

})